import React from 'react'
import Button from './Button'
import { Home } from '@mui/icons-material'
import { ReactComponent as Logo } from '../../../src/assets/icons/common/aura-logo-b.svg'
import { errors } from '../../lib/utils/toastCaller'
import { useAuth } from '../../hooks'

type FallbackError = {
	message?: string
	response?: {
		data?: {
			errorMessageCode?: string
			errors?: string[]
			message?: string
		}
	}
}

type FallbackProps = {
	customError?: string
	error?: unknown
	prefix?: string
}

const getFallbackErrorMessage = (error: unknown) => {
	const typedError = error as FallbackError | undefined
	const errorCode =
		typedError?.response?.data?.errors?.[0] ||
		typedError?.response?.data?.errorMessageCode

	return {
		errorCode: errors[errorCode]?.() || errorCode,
		errorMessage: typedError?.response?.data?.message || typedError?.message,
	}
}

const Fallback = ({ customError, error, prefix }: FallbackProps) => {
	const { logout } = useAuth()

	const { errorCode, errorMessage } = getFallbackErrorMessage(error)
	const message =
		customError || errorMessage || errorCode
			? `${prefix ? `${prefix}: ` : ''}${errorMessage}${errorCode ? ': ' + errorCode : ''
			}`
			: 'An unexpected error occurred'

	return (
		<div className="min-h-screen select-none flex flex-col items-center justify-center bg-white dark:bg-background-dark text-text-main text-center px-4">
			<div className="mb-10 flex items-center justify-center">
				<Logo className="h-16 w-16 fill-accent" />
			</div>
			<h1 className="text-3xl font-bold mb-4">
				Ooops, something went wrong...
			</h1>
			<p className="mb-6 text-gray-400">
				{message}, please report the issue to{' '}
				<a
					href="mailto:support@solarion.ai"
					className="text-accent hover:underline"
				>
					support@solarion.ai
				</a>
			</p>
				{['USER_NOT_FOUND', 'ACCESS_DENIED'].includes(errorCode) ? (
					<Button
						className="w-40"
						variant="secondary"
						label="Back to Login"
						onClick={() => logout()}
					/>
				) : (
					<Button
						leftIcon={<Home />}
						label="Go back home"
						onClick={() => window.location.replace('/aura/home')}
					/>
				)}
		</div>
	)
}

export default Fallback
